import { useState , useCallback} from "react";
import * as Sentry from '@sentry/react';

const useAudioPermission = () => {
  const [noAccess, setNoAccess] = useState(false);
  const [noPermission, setNoPermission] = useState(false);

  const checkAudioPermission = useCallback(async() => {
    try {
        const isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
        let permissionState = null;
        if (navigator.permissions && !isFirefox) {
          const permissionStatus = await 
          navigator.permissions
          .query({ name: "microphone" });
          permissionState = permissionStatus.state;
          
          if (permissionStatus.state === "denied") {
            setNoAccess(false);
            setNoPermission(true);
          }
          permissionStatus.onchange = function () {
            if (this.state === "denied") {
              setNoAccess(false);
              setNoPermission(true);
            } else {
              setNoAccess(false);
              setNoPermission(false);
            }
          };
        }
        if (navigator?.mediaDevices && !isFirefox && permissionState !== "denied") {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              stream.getTracks().forEach((_tr) => _tr.stop());
              setNoAccess(false);
              setNoPermission(false);
            })
            .catch(() => {
              Sentry.captureException(`364 error in checkAudioPermission`);
              setNoAccess(true);
              setNoPermission(false);
            });
        }
    } catch (error) {
      Sentry.captureException(`365 error in checkAudioPermission`);
      setNoPermission(true);
    }
  }, [setNoAccess, setNoPermission]);
  return { noAccess, noPermission, checkAudioPermission };
};

export default useAudioPermission;
